import { create } from 'zustand';

export type RecordingMobileLockModalStore = {
  close: () => void;
  dismissedThisSession: boolean;
  isOpen: boolean;
  open: () => void;
  reset: () => void;
};

const initialState = {
  dismissedThisSession: false,
  isOpen: false,
};

export const useRecordingMobileLockModalStore = create<RecordingMobileLockModalStore>((set) => ({
  ...initialState,
  close: () => set({ dismissedThisSession: true, isOpen: false }),
  open: () => set({ isOpen: true }),
  reset: () => set(initialState),
}));
